import { Observable } from "rxjs";
import { get, post } from "../utils/axios";
import sessionService from "./session.service";

class MapWeatherReportService {
 
  getMapReport(address: number , patientId : number): Observable<any> { 
    return post(`${sessionService.getClient()?.appServiceUrl}/patient/geocode`, {
      address: address,
      memberId: patientId
    });
  }

  getPostalCode(postalCode: number , patientId: number): Observable<any> {
    const param  = (postalCode ? `pinCode=${postalCode}&` : '') + `patientId=${patientId}`
    return get(`${sessionService.getClient()?.appServiceUrl}/patient/weather-report?${param}`)
  }

  getForecastsData(locationKey: string): Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/patient/weather-forecast/${locationKey}`)
  }

}

export default new MapWeatherReportService();
